/**
 * @param {(...args: unknown[]) => void} fn - The function to debounce.
 * @param {number} delay - The delay in milliseconds.
 * @returns {((...args: unknown[]) => void) & { cancel: () => void }} The debounced function.
 * @example
 * const debouncedFunction = debounce(() => { console.log('Hello World'); }, 1000);
 */
export const debounce = (fn, delay) => {
  let timeoutId = null;
  const debounced = function debounced(...args) {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    const context = this;
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn.apply(context, args);
    }, delay);
  };

  debounced.cancel = () => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return debounced;
};
